<template>
  <div>
    <Header></Header>
    <div class="information_Data w1200">
      <div class="information_top">
        <el-form
          :label-position="labelPosition"
          :model="formLabelAlign"
          :rules="rules"
          ref="formLabelAlign"
        >
          <div class="title">
            账户信息
          </div>
          <el-form-item class="Cutter_box">
            <div class="sdsds">
              <div class="ico_box_03" v-if="!formLabelAlign.HeadUrl"></div>
              <el-avatar
                :size="100"
                v-if="formLabelAlign.HeadUrl"
                :src="formLabelAlign.HeadUrl"
              ></el-avatar>
              <ImgCutter
                label="选择图片"
                :isModal="true"
                :boxWidth="400"
                :boxHeight="300"
                :cutWidth="200"
                :cutHeight="200"
                :sizeChange="true"
                :moveAble="true"
                :tool="false"
                WatermarkText=""
                v-on:cutDown="cutDown"
              >
                <div class="cutter_Img" slot="open">上传头像</div>
              </ImgCutter>
            </div>
          </el-form-item>
          <div class="Cutter_box_item" style="margin-bottom: 0;">
            <el-form-item prop="NickName" style="margin-bottom: 0;">
              <div class="tit">
                用户昵称
              </div>
              <el-input
                v-model="formLabelAlign.NickName"
                placeholder="不超过6个汉字、18个字母、18个数字"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <div class="tit">
                手机号
              </div>
              <el-input
                readonly
                class="phone_width no_border"
                v-model="formLabelAlign.MobileNumber"
              ></el-input>
              <!-- <span class="change_phone" @click="change_phone()"
                ><img src="../../assets/personal/xiugai.png"
              /></span> -->
            </el-form-item>
          </div>
          <div class="title">
            学员信息
          </div>
          <div class="Cutter_box_item">
            <el-form-item prop="RealName">
              <div class="tit">
                学员姓名
              </div>
              <el-input
                v-model="formLabelAlign.RealName"
                placeholder="请输入真实姓名"
                :disabled="jzsr"
              >
              </el-input>
            </el-form-item>

            <el-form-item prop="EnglishName">
              <div class="tit">
                英文名
              </div>
              <el-input
                v-model="formLabelAlign.EnglishName"
                placeholder="请输入英文名"
              ></el-input>
            </el-form-item>
          </div>
          <div class="Cutter_box_item">
            <el-form-item prop="Sex">
              <div class="tit">
                性别
              </div>
              <el-select
                v-model="formLabelAlign.Sex"
                placeholder="请选择"
                @change="SexChange"
                style="width: 360px;"
              >
                <el-option label="男" value="男"> </el-option>
                <el-option label="女" value="女"> </el-option>
              </el-select>
            </el-form-item>
            <!-- 生日 -->
            <el-form-item prop="Birthday">
              <div class="tit">
                生日
              </div>
              <el-radio-group>
                <div class="block birthdays">
                  <el-date-picker
                    v-model="formLabelAlign.Birthday"
                    value-format="yyyy-MM-dd"
                    @change="selectTime"
                    type="date"
                    placeholder="选择日期"
                  >
                  </el-date-picker>
                </div>
              </el-radio-group>
            </el-form-item>
            <!-- 城市 -->
            <el-form-item prop="">
              <div class="tit">
                城市
              </div>
              <div class="city_box">
                <el-select
                  v-model="Province"
                  placeholder="请选择省份"
                  @change="ChangeProvince"
                  ref="sf"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-select
                  v-model="city"
                  placeholder="请选择城市"
                  @change="ChangeCity"
                  ref="sq"
                >
                  <el-option
                    v-for="item in options1"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
          </div>
          <div class="Cutter_box_item" style="margin-bottom: 0;">
            <el-form-item>
              <div class="tit">
                所在学校
              </div>
              <el-input
                v-model="formLabelAlign.School"
                placeholder="请填写所在学校"
              ></el-input>
            </el-form-item>

            <el-form-item prop="">
              <div class="tit">
                所在年级
              </div>
              <el-cascader
                :options="grades"
                v-model="selectedOptions"
                :props="defaultParams"
                @change="changeGrades"
                style="width: 360px;"
              >
              </el-cascader>
            </el-form-item>
          </div>
          <div class="title">
            目标设置
          </div>
          <div class="Cutter_box_item" style="margin-bottom: 0;">
            <el-form-item prop="PlanExamTime">
              <div class="tit">
                计划考试日期
              </div>
              <el-date-picker
                v-model="formLabelAlign.PlanExamTime"
                value-format="yyyy-MM-dd"
                @change="examsDate"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
            <!-- 课程 -->
            <el-form-item>
              <div class="tit">
                课程
              </div>
              <el-select
                v-model="CoursesValue"
                placeholder="请选择"
                @change="CoursesFunc"
                style="width: 360px;"
              >
                <el-option
                  v-for="item in Courses"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- 分数 -->
            <el-form-item>
              <div class="tit">
                目标分数
              </div>
              <el-select
                v-model="targetScoreValue"
                placeholder="请选择"
                @change="targetScoreFunc"
                style="width: 360px;"
              >
                <el-option
                  v-for="item in targetScoreList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
        <div class="edit_psd">
          <div class="title">
            修改密码
          </div>
          <div class="psd_main">
            <div class="psd_left">
              <img
                src="@/assets/login/password_icon.png"
                class="psd_icon"
                alt=""
              />
              <div class="psd_text">
                <div class="text_title">登录密码</div>
                <div class="text_desc">用于保护账号信息及登录安全</div>
              </div>
            </div>
            <div class="psd_right" @click="setPsd">设置密码</div>
          </div>
        </div>
      </div>
      <div class="editor_btn">
        <el-button type="primary" @click="submitForm('formLabelAlign')" round
          >保存</el-button
        >
      </div>
      <!-- 修改手机号弹窗 -->
      <div class="phone_wrap" v-show="tkshow">
        <div class="phone_tkBox">
          <p class="dele_btn" @click="dele_btn">
            <img src="../../assets/personal/address_dele.png" alt="" />
          </p>
          <div class="tk_content">
            <h2 class="phone_h2">修改手机号码</h2>
            <p>
              当前手机号码：<span>{{ formLabelAlign.MobileNumber }}</span>
            </p>
            <el-form
              :label-position="labelPosition"
              label-width="34px"
              :model="formPhone"
              :rules="rules"
              ref="formPhone"
            >
              <el-form-item prop="phone" :error="phoneErrorMsg">
                <el-input
                  v-model="formPhone.phone"
                  placeholder="请输入新手机号码"
                >
                  <el-select v-model="formPhone.area_code" slot="prepend">
                    <el-option
                      :value="item.code"
                      :label="'+' + item.code"
                      :key="index"
                      v-for="(item, index) in countryCodeList"
                      >+{{ item.code + " " + item.cn }}</el-option
                    >
                  </el-select>
                </el-input>
              </el-form-item>
              <el-form-item prop="verifycode" class="yzm_iput">
                <el-input
                  v-model="formPhone.verifycode"
                  placeholder="请输入6位数的验证码"
                  maxlength="6"
                ></el-input>
                <el-button
                  @click="getCode('registereds')"
                  plain
                  class="get_yzm"
                  >{{ getCodes }}</el-button
                >
              </el-form-item>
            </el-form>
          </div>
          <div class="set_btn">
            <el-button @click="submitphone('formPhone')" round class="button1"
              >确认修改</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <div v-if="psdVerVIsible" class="psd_ver_dialog">
      <!-- <div class="psd_ver_main" v-if="psdStatus == 1">
        <div class="psd_ver">
          <div class="close_handle" @click="psdVerVIsible = false">
            <img
              src="@/assets/login/modal_close.png"
              class="modal_close"
              alt=""
            />
          </div>
          <div class="verify_title">
            安全验证
          </div>
          <div class="verify_desc">
            为了保障您的账户安全，请先验证密码
          </div>
          <el-form
            :model="psdForm"
            :rules="rules"
            ref="psdForm"
            class="psdForm"
          >
            <el-form-item prop="password" :inline="true">
              <el-input
                v-model="psdForm.password"
                minlength="6"
                maxlength="20"
                placeholder="请输入密码"
                show-password
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="modal_btn">
          <el-button
            @click="nextHandle"
            type="default"
            round
            class="btn_view btn_confirm"
            >下一步</el-button
          >
          <el-button
            @click="psdVerVIsible = false"
            type="default"
            round
            class="btn_view btn_cancle"
            >取消</el-button
          >
        </div>
      </div> -->
      <div class="psd_ver_main" v-if="psdStatus == 1">
        <div class="psd_ver">
          <div class="close_handle" @click="closeDialog">
            <img
              src="@/assets/login/modal_close.png"
              class="modal_close"
              alt=""
            />
          </div>
          <div class="verify_title">
            安全验证
          </div>
          <div class="verify_desc">
            为了保障您的账户安全，请先进行验证
          </div>
          <el-form
            :model="psdForm"
            :rules="rules"
            ref="psdForm"
            class="psdForm"
          >
            <el-form-item prop="mobileCode" class="yzm_iput">
              <el-input
                v-model="psdForm.mobileCode"
                placeholder="请输入6位数的验证码"
                maxlength="6"
              ></el-input>
              <el-button @click="getCode('psdForm')" plain class="get_yzm">{{
                getCodes
              }}</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="modal_btn">
          <el-button
            @click="nextHandle"
            :loading="psdLoading"
            type="default"
            round
            class="btn_view btn_confirm"
            >下一步</el-button
          >
          <el-button
            @click="closeDialog"
            type="default"
            round
            class="btn_view btn_cancle"
            >取消</el-button
          >
        </div>
      </div>
      <div class="psd_ver_main" v-else-if="psdStatus == 2">
        <div class="psd_ver">
          <div class="close_handle" @click="closeDialog">
            <img
              src="@/assets/login/modal_close.png"
              class="modal_close"
              alt=""
            />
          </div>
          <div class="verify_title" style="margin-bottom: 20px;">
            修改密码
          </div>
          <el-form
            :model="psdForm"
            :rules="rules"
            ref="psdForm"
            class="psdForm"
          >
            <div class="form_item_label">新密码</div>
            <el-form-item prop="password" :inline="true">
              <el-input
                v-model="psdForm.password"
                minlength="6"
                maxlength="20"
                placeholder="请输入密码"
                show-password
              ></el-input>
            </el-form-item>
            <div class="form_item_label">确认密码</div>
            <el-form-item prop="againPassword" :inline="true">
              <el-input
                v-model="psdForm.againPassword"
                minlength="6"
                maxlength="20"
                placeholder="请输入密码"
                show-password
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="modal_btn">
          <el-button
            :loading="psdLoading"
            @click="confirmEditPsd"
            type="default"
            round
            class="btn_view btn_confirm"
            >确认</el-button
          >
          <el-button
            @click="closeDialog"
            type="default"
            round
            class="btn_view btn_cancle"
            >取消</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../components/header/Header.vue";
import ImgCutter from "vue-img-cutter";
import jq from "../../../static/jquery.min.js";
import myCaptcha from "@/common/js/myCaptcha";
import urlObj from "@/api/baseUrl";
name: "editor";
export default {
  components: {
    Header,
    ImgCutter,
    jq
  },
  data() {
    // 手机号验证
    var checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[3|4|5|6|7|8][0-9]{9}$/;
      if (!value) {
        return callback(new Error("电话号码不能为空"));
      }
      setTimeout(() => {
        if (!Number.isInteger(+value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (phoneReg.test(value)) {
            callback();
          } else {
            callback(new Error("电话号码格式不正确"));
          }
        }
      }, 100);
    };
    return {
      labelPosition: "right",
      tokenkey: "",
      formLabelAlign: {
        HeadUrl: "", //头像
        NickName: "", //昵称
        RealName: "", //学员姓名
        EnglishName: "", //英文名
        MobileNumber: "", //修改手机号
        Sex: "", //性别
        Birthday: "", //生日
        Region: "", //所在区域, '-' 隔开 ,
        School: "", //所在学校
        Grade: "", //所在年级
        PlanExamTime: "", //计划考试时间
        TestSubjects: "", //备考科目
        TargetScore: "" //目标分数
      },
      // 区号
      countryCodeList: [],
      getCodes: "获取验证码",
      phoneErrorMsg: "",
      formPhone: {
        area_code: 86,
        phone: "",
        verifycode: "",
        checked: false
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      value1: "",
      value2: "",
      value: [],
      options: [],
      options1: [],
      tkshow: "",

      jzsr: false, //学员姓名（修改后禁止输入）
      EnglishName: "", //英文名
      Sex: "", //性别
      Province: "", //省份
      city: "", //城市
      // szGrade: '', //所在年级
      grades: [], //年级
      selectedOptions: ["高中", "二年级"],
      defaultParams: {
        label: "label",
        value: "label",
        children: "children"
      },
      Courses: [], //课程选择
      targetScoreList: [], //目标分数
      CoursesValue: "",
      targetScoreValue: "",
      targetScoreId: "",
      kcNumber: "",
      enumList: "",

      rules: {
        phone: [
          {
            required: true,
            message: "电话号码不能为空",
            trigger: "blur"
          }
        ],
        NickName: [
          {
            required: true,
            message: "请输入昵称",
            trigger: "blur"
          }
          // {
          //   min: 2,
          //   max: 6,
          //   message: '长度在 3 到 5 个字符',
          //   trigger: 'blur'
          // }
        ],
        RealName: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur"
          },
          {
            min: 2,
            max: 6,
            message: "长度在 3 到 5 个字符",
            trigger: "blur"
          }
        ],
        EnglishName: [
          {
            required: true,
            message: "请输入英文名",
            trigger: "blur"
          }
          // {
          //   min: 2,
          //   max: 6,
          //   message: '长度在 3 到 5 个字符',
          //   trigger: 'blur'
          // }
        ],
        Sex: [
          {
            required: true,
            message: "请选择性别",
            trigger: "blur"
          }
        ],
        // birthdays: [{
        //   type: 'date',
        //   required: true,
        //   message: '请选择日期',
        //   trigger: 'change'
        // }],
        MobileNumber: [
          {
            required: true,
            validator: checkPhone,
            trigger: "blur"
          }
        ],
        // Region: [{

        // }],
        verifycode: [
          {
            required: true,
            message: "验证码不能为空",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "密码不能为空",
            trigger: "blur"
          },
          {
            min: 6,
            max: 20,
            message: "长度在 6 到 20 个字符",
            trigger: "blur"
          }
        ],
        againPassword: [
          {
            required: true,
            message: "密码不能为空",
            trigger: "blur"
          },
          {
            min: 6,
            max: 20,
            message: "长度在 6 到 20 个字符",
            trigger: "blur"
          }
        ],
        mobileCode: [
          {
            required: true,
            message: "验证码不能为空",
            trigger: "blur"
          }
        ]
      },
      psdVerVIsible: false,
      psdStatus: 1,
      psdForm: {
        area_code: 86,
        phone: "",
        password: "",
        againPassword: "",
        mobileCode: ""
      },
      psdLoading: false
    };
  },
  created() {
    let that = this;

    console.log(that);
    that.tokenkey = that.$cookies.get("token");
    // // console.log(that.$cookies.get("token"))
    //用户信息
    if (that.$cookies.get("token")) {
      that.$http
        .get("https://schoolapi.eiceducation.com.cn/api/UserInfo", {
          headers: {
            token: that.$cookies.get("token")
          }
        })
        .then(function(result) {
          if (that.tokenkey) {
            that.$store.commit("setUserInfo", result.data.results);
          } else {
            that.$store.commit("setUserInfo", {
              Type: 1
            });
          }
          // // console.log(result.data.results)
          that.formLabelAlign.HeadUrl = result.data.results.HeadUrl; //头像
          that.formLabelAlign.NickName = result.data.results.NickName; //昵称
          var tel = result.data.results.MobileNumber;
          var reg = /^(\d{3})\d{4}(\d{4})$/;
          that.formLabelAlign.MobileNumber = tel.replace(reg, "$1****$2");
          that.psdForm.phone = result.data.results.MobileNumber; //手机号
          that.psdForm.area_code = result.data.results.MobileAreaCode; //区号
          that.formLabelAlign.RealName = result.data.results.RealName; //学员姓名
          that.formLabelAlign.EnglishName = result.data.results.EnglishName; //英文名
          that.formLabelAlign.Sex = result.data.results.Sex; //性别
          that.formLabelAlign.Birthday = result.data.results.Birthday; //生日
          that.formLabelAlign.Region = result.data.results.Region.split("-"); //省份-城市
          that.Province = that.formLabelAlign.Region[0]; //省份
          that.city = that.formLabelAlign.Region[1]; //城市
          that.formLabelAlign.School = result.data.results.School; //学校
          that.formLabelAlign.Grade = result.data.results.Grade; //年级JSON.parse()
          that.selectedOptions = result.data.results.Grade.split("-"); //年级
          that.formLabelAlign.PlanExamTime = result.data.results.PlanExamTime; //学校
          that.CoursesValue = result.data.results.TestSubjectName; //课程

          that.formLabelAlign.TestSubjects = result.data.results.TestSubjects; //未点击科目（默认原有的Id）
          that.formLabelAlign.TargetScore = result.data.results.TargetScore;

          that.targetScoreId = result.data.results.TestSubjects; //初始点击目标分数（如果已有科目）
          if (that.targetScoreId) {
            let ScoresArray = [];
            that.enumList.forEach(function(item, i) {
              if (item.Id === that.targetScoreId) {
                item.List.forEach(function(item, i) {
                  if (item.Type === 1) {
                    var ScoresObj = new Object();
                    ScoresObj.value = i;
                    ScoresObj.label = item.Name;
                    ScoresObj.Id = item.Id;
                    ScoresArray.push(ScoresObj);
                  }
                });
                that.targetScoreList = ScoresArray;
              }
            });
          }
          if (that.targetScoreList.length) {
            let target = that.targetScoreList.find(
              item1 => item1.Id == result.data.results.TargetScore
            );
            if (target) {
              that.targetScoreValue = target.value; //目标分数
            }
          }
          console.log("targetScoreList", that.targetScoreList);
        })
        .catch(function() {
          // console.log('00');
        });
    }

    //判断是否禁止输入
    // if (that.formLabelAlign.RealName) {
    //   that.jzsr = true
    // }
    //城市筛选
    this.$http
      .get("/static/city-data2.json")
      .then(function(response) {
        let ids = sessionStorage.getItem("ids");
        //判断是否点击过省份
        if (ids) {
          //省份
          let itemList2 = response.data;
          var obj = [];
          itemList2.forEach((item, index) => {
            obj.push({
              label: item.label,
              value: item.value
            });
          });
          that.options = obj;
          //城市
          let itemList = response.data[ids].children;
          var obj1 = [];
          itemList.forEach((item, index) => {
            obj1.push({
              label: item.label,
              value: item.value
            });
          });
          that.options1 = obj1;
        } else {
          let itemList2 = response.data;
          var obj = [];
          itemList2.forEach((item, index) => {
            obj.push({
              label: item.label,
              value: item.value
            });
          });
          that.options = obj;
        }
      })
      .catch(function() {
        // console.log('00');
      });
    // 年级
    that.$http
      .get("/static/grade.json")
      .then(function(result) {
        // // console.log(result)
        that.grades = result.data;
      })
      .catch(function() {
        // console.log('00');
      });

    //课程筛选
    let a = sessionStorage.getItem("enum");
    this.enumList = JSON.parse(a)[0].List;
    // // console.log(this.enumList)
    var jsonData = [];
    this.enumList.forEach(function(item, i) {
      var signAgainReq = new Object();
      signAgainReq.value = i;
      signAgainReq.label = item.Name;
      jsonData.push(signAgainReq);
    });
    this.Courses = jsonData;
  },
  mounted() {
    this.getCountryCodeList();
  },
  methods: {
    closeDialog() {
      this.psdVerVIsible = false;
      this.psdStatus = 1;
      this.psdForm.password = "";
      this.psdForm.againPassword = "";
      this.psdForm.mobileCode = "";
      this.stopInterVal();
    },
    confirmEditPsd() {
      if (this.psdLoading) return;
      this.$refs.psdForm.validate(valid => {
        if (valid) {
          let {
            password,
            againPassword,
            mobileCode,
            area_code,
            phone
          } = this.psdForm;
          if (password != againPassword) {
            this.$message.error("两次密码不一致");
            return;
          }
          this.psdLoading = true;
          this.$http
            .post(
              urlObj.passport + "ChangePassword",
              {
                areaCode: area_code,
                mobile: phone,
                passWord: password,
                mobileCode,
                systemPaaS: 6,
                paaSPort: 1
              },
              {
                headers: {
                  token: this.$cookies.get("token"),
                  Authorization: "Bearer " + this.$cookies.get("token")
                }
              }
            )
            .then(response => {
              if (response.data.succ) {
                this.$message.success("修改成功");
                // this.$cookies.remove("token");
                this.closeDialog();
              } else {
                this.$message.error(response.data.msg);
              }
              this.psdLoading = false;
            })
            .catch(error => {
              this.$message.error(error);
              this.psdLoading = false;
            });
        } else {
          return false;
        }
      });
    },
    nextHandle() {
      if (this.psdLoading) return;
      this.$refs.psdForm.validate(valid => {
        if (valid) {
          let { mobileCode, area_code, phone } = this.psdForm;
          this.psdLoading = true;
          this.$http
            .post(
              urlObj.passport + "MobileCode/VerifyCode",
              {
                areaCode: area_code,
                mobile: phone,
                systemPaaS: 6,
                paaSPort: 1,
                codeType: 3,
                signName: "启德教育",
                code: mobileCode,
                isFailure: false
              },
              {
                headers: {
                  token: this.$cookies.get("token")
                }
              }
            )
            .then(res => {
              console.log("res", res);
              if (res.data.succ) {
                this.psdStatus = 2;
                this.stopInterVal();
              } else {
                this.$message.error(res.data.msg);
              }
              this.psdLoading = false;
            })
            .catch(error => {
              this.$message.error(error);
              this.psdLoading = false;
            });
        } else {
          return false;
        }
      });
    },
    setPsd() {
      this.psdVerVIsible = true;
    },
    change_phone() {
      this.tkshow = true;
    },
    //手机号码归属国家区号
    getCountryCodeList() {
      console.log("123");
      this.$http
        .get("https://api-kt.eiceducation.com.cn/api/country/getCountryCodeList")
        .then(res => {
          console.log(res);
          if (res.data.succ) {
            let codeList = [];
            codeList = res.data.results;
            this.countryCodeList = codeList;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    stopInterVal() {
      this.getCodes = "获取验证码";
      clearInterval(this.yz_timer);
      this.yz_timer = null;
    },
    codeLogic(res) {
      const TIME_COUNT = 60;
      var phones = this.formPhone.phone;
      var areaCode = this.formPhone.area_code;
      if (this.psdVerVIsible) {
        phones = this.psdForm.phone;
        areaCode = this.psdForm.area_code;
      }

      this.$http
        .post(
          urlObj.passport + "MobileCode/SendSmsCode",
          {
            areaCode,
            mobile: phones,
            systemPaaS: 6,
            paaSPort: 1,
            codeType: 3,
            ticket: res.ticket,
            randstr: res.randstr,
            signName: "启德教育"
          },
          {
            headers: {
              token: this.$cookies.get("token")
            }
          }
        )
        .then(response => {
          console.log("验证码倒计时", response);
          sessionStorage.setItem("codeType", 3);
          if (!response.data.succ) {
            this.$message.error(response.data.msg);
            this.phoneErrorMsg = response.data.msg;
          } else {
            this.yz_count = TIME_COUNT;
            this.getCodes = this.yz_count + "S后重新获取";
            this.yz_timer = setInterval(() => {
              if (this.yz_count > 0 && this.yz_count <= TIME_COUNT) {
                this.yz_count--;
                this.getCodes = this.yz_count + "S后重新获取";
              } else {
                this.getCodes = "重新获取验证码";
                clearInterval(this.yz_timer);
                this.yz_timer = null;
              }
            }, 1000);
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    },
    // 验证码倒计时
    getCode(index) {
      if (index == "psdForm") {
        if (!this.yz_timer) {
          if (!this.psdForm.phone) {
            this.$message.error("请填写手机号");
            return;
          }
          myCaptcha(this.codeLogic);
        }
      } else {
        let that = this;
        that.phoneErrorMsg = "";
        this.$refs[index].validateField(["phone"], formError => {
          console.log("formError", formError);
          if (!formError) {
            if (!this.yz_timer) {
              myCaptcha(this.codeLogic);
            }
          } else {
            return false;
          }
        });
      }
    },
    submitphone(formName) {
      var that = this;
      var phone = this.formPhone.phone;
      var code = this.formPhone.verifycode;
      var areaCode = this.formPhone.area_code;
      that.phoneErrorMsg = "";
      this.$refs[formName].validate(valid => {
        // // console.log(valid)
        if (valid) {
          let params = {
            mobile: phone,
            mobileCode: code,
            areaCode: areaCode,
            systemPaaS: 6,
            paaSPort: 1
          };
          this.$http
            .post(urlObj.passport + "ChangeMobile", params, {
              headers: {
                token: this.$cookies.get("token"),
                Authorization: "Bearer " + this.$cookies.get("token")
              }
            })
            .then(function(response) {
              // // console.log(response)
              if (response.data.succ) {
                that.$message({
                  message: "修改成功",
                  type: "success"
                });
                that.tkshow = false;
                that.formLabelAlign.MobileNumber = that.formPhone.phone;
              } else {
                that.$message.error(response.data.msg);
              }
              // if (response.data.code == 200) {
              //   that.$message({
              //     message: "修改成功",
              //     type: "success"
              //   });
              //   this.tkshow = false;
              //   that.formLabelAlign.MobileNumber = that.formPhone.phone;
              // } else if (response.data.code == 500) {
              //   that.phoneErrorMsg = response.data.msg;
              // } else {
              //   that.$message.error(response.data.msg);
              // }
            })
            .catch(function(error) {
              that.$message.error(error);
            });
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    //生日
    selectTime(BirthdayTime) {
      let that = this;
      that.formLabelAlign.Birthday = BirthdayTime;
    },
    examsDate(examsDate) {
      let that = this;
      that.formLabelAlign.PlanExamTime = examsDate;
    },
    dele_btn() {
      this.tkshow = false;
    },
    //性别
    SexChange(Sex) {
      let that = this;
      console.log(Sex);
      that.formLabelAlign.Sex = Sex;
    },
    changeGrades(e) {
      let that = this;
      // console.log(e)
      let nj = e[0];
      let bj = e[1];
      that.formLabelAlign.Grade = nj + "-" + bj;
    },
    cutDown(res) {
      //图片剪切
      let that = this;
      let formData = new FormData();
      formData.append("file", res.file);
      that.$http
        .get("https://schoolapi.eiceducation.com.cn/api/UserInfo", {
          headers: {
            token: that.$cookies.get("token")
          }
        })
        .then(function(result) {
          // 上传图片接口
          $.ajax({
            type: "POST",
            url: "https://schoolapi.eiceducation.com.cn/api/Image",
            data: formData,
            async: false,
            dataType: "json",
            cache: false,
            processData: false,
            contentType: false,
            headers: {
              ContentType: "multipart/form-data",
              token: that.tokenkey
            },
            success: function(data) {
              if (data.code == 200) {
                that.formLabelAlign.HeadUrl = data.results;
                // // console.log(that.formLabelAlign.HeadUrl)
              }
            },
            error: function() {
              alert("error");
            }
          });
        })
        .catch(function() {
          // console.log('数据错误');
        });
    },
    //省份
    ChangeProvince(e) {
      var ids = e - 1;
      let that = this;
      sessionStorage.setItem("ids", e - 1);
      that.city = "";
      that.formLabelAlign.Region = "";
      this.$http
        .get("/static/city-data2.json")
        .then(function(response) {
          let itemList = response.data[ids].children;
          var obj = [];
          itemList.forEach((item, index) => {
            obj.push({
              label: item.label,
              value: item.value
            });
          });
          that.options1 = obj;
          let city = JSON.stringify(obj);
          sessionStorage.setItem("city", city);
          that.Province = response.data[ids].label;
        })
        .catch(function() {
          // console.log('00');
        });
    },
    //城市
    ChangeCity(e) {
      let that = this;
      let cs = sessionStorage.getItem("city");
      let options1 = JSON.parse(cs);
      var obj = [];
      options1.forEach((item, index) => {
        if (item.value == e) {
          obj.push({
            label: item.label
          });
        }
      });
      that.city = obj[0].label;
      that.$cookies.get("city");
      that.formLabelAlign.Region = that.Province + "-" + that.city;
    },
    //课程
    CoursesFunc(val) {
      let that = this;
      this.kcNumber = val;
      var targets = this.enumList[val].List;
      let ScoresArray1 = [];
      let ScoresArray2 = [];
      targets.forEach(function(item, i) {
        if (item.Type === 1) {
          // console.log(item.Id)
          var ScoresObj = new Object();
          ScoresObj.Id = item.Id;
          ScoresObj.value = i;
          ScoresObj.label = item.Name;
          ScoresArray1.push(ScoresObj);
        }
      });
      // console.log(ScoresArray1)
      this.targetScoreValue = "";
      this.targetScoreList = ScoresArray1;
      this.formLabelAlign.TestSubjects = this.enumList[val].Id; //课程赋值
    },
    //目标分数
    targetScoreFunc(val) {
      let that = this;
      that.formLabelAlign.TargetScore = that.targetScoreList[val].Id; //课程赋值
    },
    //提交表单提示框（成功）
    successHint() {
      this.$message({
        message: "恭喜你，个人信息提交成功",
        type: "success"
      });
    },
    //提交表单提示框（成功）
    errorHint() {
      this.$message({
        message: "信息未填全",
        type: "warning"
      });
    },
    // 提交表单
    async submitForm(formName) {
      let that = this;
      console.log("that.formLabelAlign", this.formLabelAlign);
      if (
        this.formLabelAlign.Region &&
        Object.prototype.toString.call(this.formLabelAlign.Region) ===
          "[object Array]" &&
        this.formLabelAlign.Region.length
      ) {
        this.formLabelAlign.Region = this.formLabelAlign.Region.join("-");
      }
      let parameter = {
        HeadImage: this.formLabelAlign.HeadUrl,
        BirthDate: this.formLabelAlign.Birthday,
        RealName: this.formLabelAlign.RealName,
        Sex: this.formLabelAlign.Sex == "女" ? 0 : 1,
        Region: this.formLabelAlign.Region
      };
      let userId = "";
      if (this.$cookies.get("token")) {
        await this.$http
          .get("https://schoolapi.eiceducation.com.cn/api/UserInfo", {
            headers: {
              token: this.$cookies.get("token")
            }
          })
          .then(res => {
            if (res.data.succ) {
              let { results } = res.data;
              userId = results.Id;
            }
          });
      }
      let parameterArr = [];
      for (let k in parameter) {
        parameterArr.push({
          name: k,
          value: parameter[k]
        });
      }
      parameterArr = parameterArr.filter(item => item.value);
      console.log("parameterArr", parameterArr);
      await this.$http
        .put(
          `${urlObj.passport + "UserInfo"}/${userId}`,
          JSON.stringify(parameterArr),
          {
            headers: {
              token: this.$cookies.get("token"),
              Authorization: "Bearer " + this.$cookies.get("token"),
              "content-type": "application/json; charset=utf-8"
            }
          }
        )
        .then(res => {
          console.log(res, "res");
        });
      this.$refs[formName].validate(valid => {
        if (valid) {
          $.ajax({
            type: "POST",
            url: "https://schoolapi.eiceducation.com.cn/api/UserInfo",
            data: that.formLabelAlign,
            dataType: "json",
            headers: {
              ContentType: "application/json",
              token: that.tokenkey
            },
            success: function(data) {
              // // console.log(data)
              that.successHint();
              that.$router.go(-1);
            },
            error: function() {
              alert("error");
            }
          });
        } else {
          that.errorHint();
          return false;
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
@import url("./editor.css");
.edit_psd {
  .psd_main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background: #fbfbfb;
    padding: 10px;
    box-sizing: border-box;
    .psd_left {
      display: flex;
      align-items: center;
      .psd_icon {
        width: 42px;
        height: 42px;
        margin-right: 10px;
      }
      .psd_text {
        .text_title {
          font-weight: 500;
          font-size: 20px;
          color: #333333;
          margin-bottom: 5px;
        }
        .text_desc {
          font-size: 14px;
          color: #666666;
        }
      }
    }
    .psd_right {
      width: 150px;
      height: 40px;
      background: #337cff;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      font-size: 20px;
      color: #ffffff;
    }
  }
}
.psd_ver_dialog {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 999;
  width: 100vw;
  height: 100vh;
  transition: all 0.2s;
  .psd_ver_main {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 12px 12px 12px 12px;
    padding: 20px 50px 57px;
    .psd_ver {
      .form_item_label {
        font-size: 16px;
        color: #666666;
        margin-bottom: 10px;
      }
      .close_handle {
        text-align: right;
        cursor: pointer;
        .modal_close {
          margin-right: -30px;
          width: 42px;
          height: 42px;
        }
      }
      .verify_title {
        font-weight: 500;
        font-size: 20px;
        color: #333333;
        margin: 10px 0;
      }
      .verify_desc {
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        margin-bottom: 20px;
      }
    }
    .modal_btn {
    display: flex;
    justify-content: center;
      .btn_view {
        width: 160px;
        &.btn_confirm {
          background: #ff0659;
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/editor/editor.vue